// import { React } from 'react';
// import vid2 from '../Assets/videos/vdbg.mp4';

// const AboutHome = () => {
//     const newLocal = (
//         <div class="icon style-color">
//             <i aria-hidden="true" class=""></i>
//         </div>
//     );

//     return (
//         <>
//             <div class="elementor-element elementor-element-aceda80 e-flex e-con-boxed e-con e-parent" data-id="aceda80" data-element_type="container" data-settings="{&quot;content_width&quot;:&quot;boxed&quot;}" data-core-v316-plus="true">
//                 <div class="e-con-inner">
//                     <div class="elementor-element elementor-element-69de9a7 e-flex e-con-boxed e-con e-child" data-id="69de9a7" data-element_type="container" data-settings="{&quot;background_background&quot;:&quot;classic&quot;,&quot;content_width&quot;:&quot;boxed&quot;}">
//                         <div class="e-con-inner">
//                             <div class="elementor-element elementor-element-3fd95bf e-flex e-con-boxed e-con e-child" data-id="3fd95bf" data-element_type="container" data-settings="{&quot;content_width&quot;:&quot;boxed&quot;}">
//                                 <div class="e-con-inner about-home-flex-wrapper">
//                                     <div class="elementor-element elementor-element-47da202 e-con-full e-flex e-con e-child" style={{ marginLeft: '-35px', marginRight: '20px' }} data-id="47da202" data-element_type="container" data-settings="{&quot;background_background&quot;:&quot;classic&quot;,&quot;content_width&quot;:&quot;full&quot;}">
//                                         <video
//                                             className="custom-video"
//                                             autoPlay
//                                             muted
//                                             loop
//                                             playsInline
//                                             ref={(video) => { if (video) video.play(); }}
//                                         >
//                                             <source src={vid2} type="video/mp4" />
//                                             Your browser does not support the video tag.
//                                         </video>
//                                     </div>
//                                     <div class="elementor-element elementor-element-4c24650 e-con-full e-flex e-con e-child" style={{ marginRight: '-60px' }} data-id="4c24650" data-element_type="container" data-settings="{&quot;content_width&quot;:&quot;full&quot;}">
//                                         <div class="elementor-element elementor-element-e890865 elementor-widget__width-inherit elementor-widget elementor-widget-heading" data-id="e890865" data-element_type="widget" data-widget_type="heading.default">
//                                             <div class="elementor-widget-container">
//                                                 <h2 class="elementor-heading-title elementor-size-default" style={{ textAlign: 'left' }}>
//                                                     Excellence in Modern Industry Services
//                                                 </h2>
//                                             </div>
//                                         </div>
//                                         <div class="elementor-element elementor-element-5c004df elementor-widget__width-initial elementor-widget elementor-widget-text-editor" data-id="5c004df" data-element_type="widget" data-widget_type="text-editor.default">
//                                             <div class="elementor-widget-container" style={{ marginRight: '-166px', marginBottom: '30px' }}>
//                                                 <p>
//                                                     HHG Industries delivers advanced automation, robotics, and custom engineering solutions for automotive, aeronautical, and manufacturing sectors. Boost efficiency with our expertise.
//                                                 </p>
//                                             </div>
//                                         </div>
//                                         <div class="elementor-element elementor-element-412c6be e-con-full e-flex e-con e-child" data-id="412c6be" data-element_type="container">
//                                             <div class="elementor-element elementor-element-089b842 e-con-full e-flex e-con e-child" data-id="089b842">
//                                                 <div class="elementor-element elementor-element-e38a23c jkit-equal-height-disable elementor-widget elementor-widget-jkit_icon_box" data-id="e38a23c">
//                                                     <div class="elementor-widget-container">
//                                                         <div class="jeg-elementor-kit jkit-icon-box icon-position-left elementor-animation-">
//                                                             <div class="jkit-icon-box-wrapper hover-from-left">
//                                                                 <div class="icon-box icon-box-header elementor-animation-">{newLocal}</div>
//                                                                 <div class="icon-box icon-box-body"><p class="title">Affordable Price</p></div>
//                                                             </div>
//                                                         </div>
//                                                     </div>
//                                                 </div>
//                                                 <div class="elementor-element elementor-element-d3cc2d9 jkit-equal-height-disable elementor-widget elementor-widget-jkit_icon_box" data-id="d3cc2d9">
//                                                     <div class="elementor-widget-container">
//                                                         <div class="jeg-elementor-kit jkit-icon-box icon-position-left elementor-animation-">
//                                                             <div class="jkit-icon-box-wrapper hover-from-left">
//                                                                 <div class="icon-box icon-box-header elementor-animation-">
//                                                                     <div class="icon style-color"><i aria-hidden="true" class=""></i></div>
//                                                                 </div>
//                                                                 <div class="icon-box icon-box-body"><p class="title">Precision and Accuracy</p></div>
//                                                             </div>
//                                                         </div>
//                                                     </div>
//                                                 </div>
//                                             </div>
//                                             <div class="elementor-element elementor-element-5c86f0d e-con-full e-flex e-con e-child" data-id="5c86f0d">
//                                                 <div class="elementor-element elementor-element-db2044a jkit-equal-height-disable elementor-widget elementor-widget-jkit_icon_box" data-id="db2044a">
//                                                     <div class="elementor-widget-container">
//                                                         <div class="jeg-elementor-kit jkit-icon-box icon-position-left elementor-animation-">
//                                                             <div class="jkit-icon-box-wrapper hover-from-left">
//                                                                 <div class="icon-box icon-box-header elementor-animation-">
//                                                                     <div class="icon style-color"><i aria-hidden="true" class=""></i></div>
//                                                                 </div>
//                                                                 <div class="icon-box icon-box-body"><p class="title">Consistent Quality</p></div>
//                                                             </div>
//                                                         </div>
//                                                     </div>
//                                                 </div>
//                                                 <div class="elementor-element elementor-element-fb0ae2f jkit-equal-height-disable elementor-widget elementor-widget-jkit_icon_box" data-id="fb0ae2f">
//                                                     <div class="elementor-widget-container">
//                                                         <div class="jeg-elementor-kit jkit-icon-box icon-position-left elementor-animation-">
//                                                             <div class="jkit-icon-box-wrapper hover-from-left">
//                                                                 <div class="icon-box icon-box-header elementor-animation-">
//                                                                     <div class="icon style-color"><i aria-hidden="true" class=""></i></div>
//                                                                 </div>
//                                                                 <div class="icon-box icon-box-body"><p class="title">Increased Productivity</p></div>
//                                                             </div>
//                                                         </div>
//                                                     </div>
//                                                 </div>
//                                             </div>
//                                         </div>
//                                     </div>
//                                 </div>
//                             </div>
//                         </div>
//                     </div>
//                 </div>
//             </div>

//             {/* Mobile Responsiveness */}
//             <style>{`
//                 @media (max-width: 768px) {
//                     .about-home-flex-wrapper {
//                         flex-direction: column !important;
//                         margin: 0 !important;
//                         gap: 20px;
//                     }

//                     .elementor-element-47da202,
//                     .elementor-element-4c24650 {
//                         margin: 0 !important;
//                         padding: 0 15px;
//                         width: 100%;
//                     }

//                     .elementor-element-5c004df .elementor-widget-container {
//                         margin-right: 0 !important;
//                         text-align: center;
//                     }

//                     .elementor-heading-title {
//                         text-align: center !important;
//                     }

//                     .elementor-widget-jkit_icon_box .jkit-icon-box-wrapper {
//                         justify-content: center !important;
//                         text-align: center;
//                     }

//                     .elementor-element-089b842,
//                     .elementor-element-5c86f0d {
//                         flex-direction: column !important;
//                         align-items: center !important;
//                     }

//                     .custom-video {
//                         width: 100%;
//                         height: auto;
//                         border-radius: 10px;
//                     }
//                 }
//             `}</style>
//         </>
//     );
// };

// export default AboutHome;
import { React } from 'react';
import vid2 from '../Assets/videos/vdbg.mp4';

const AboutHome = () => {
    const newLocal = (
        <div className="icon style-color">
            <i aria-hidden="true" className=""></i>
        </div>
    );

    return (
        <>
            <div className="elementor-element elementor-element-aceda80 e-flex e-con-boxed e-con e-parent" data-id="aceda80" data-element_type="container">
                <div className="e-con-inner">
                    <div className="elementor-element elementor-element-69de9a7 e-flex e-con-boxed e-con e-child" data-id="69de9a7" data-element_type="container">
                        <div className="e-con-inner">
                            <div className="elementor-element elementor-element-3fd95bf e-flex e-con-boxed e-con e-child" data-id="3fd95bf" data-element_type="container">
                                <div className="e-con-inner about-home-flex-wrapper">

                                    {/* VIDEO */}
                                    <div className="about-video-col" data-id="47da202">
                                        <video
                                            className="custom-video"
                                            autoPlay
                                            muted
                                            loop
                                            playsInline
                                            ref={(video) => { if (video) video.play(); }}
                                        >
                                            <source src={vid2} type="video/mp4" />
                                            Your browser does not support the video tag.
                                        </video>
                                    </div>

                                    {/* TEXT */}
                                    <div className="about-text-col" data-id="4c24650">
                                        <div className="elementor-widget-container">
                                            <h2 className="elementor-heading-title elementor-size-default">
                                                Excellence in Modern Industry Services
                                            </h2>
                                        </div>
                                        <div className="elementor-widget-container about-desc">
                                            <p>
                                                HHG Industries delivers advanced automation, robotics, and custom engineering solutions for automotive, aeronautical, and manufacturing sectors. Boost efficiency with our expertise.
                                            </p>
                                        </div>
                                        <div className="about-features-grid">
                                            <div className="feature-item">
                                                {newLocal}
                                                <p className="title">Affordable Price</p>
                                            </div>
                                            <div className="feature-item">
                                                <div className="icon style-color"><i aria-hidden="true" className=""></i></div>
                                                <p className="title">Consistent Quality</p>
                                            </div>
                                            <div className="feature-item">
                                                <div className="icon style-color"><i aria-hidden="true" className=""></i></div>
                                                <p className="title">Precision and Accuracy</p>
                                            </div>
                                            <div className="feature-item">
                                                <div className="icon style-color"><i aria-hidden="true" className=""></i></div>
                                                <p className="title">Increased Productivity</p>
                                            </div>
                                        </div>
                                    </div>

                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <style>{`

              /* ===== BASE — Desktop ===== */
              .about-home-flex-wrapper {
                display: flex !important;
                flex-direction: row !important;
                align-items: center !important;
                gap: 40px !important;
                padding: 40px 20px !important;
                max-width: 1300px;
                margin: 0 auto;
                box-sizing: border-box;
              }

              .about-video-col {
                flex: 1;
                min-width: 0;
              }

              .custom-video {
                width: 100% !important;
                height: auto !important;
                border-radius: 12px;
                display: block;
              }

              .about-text-col {
                flex: 1;
                min-width: 0;
              }

              .about-text-col .elementor-heading-title {
                font-size: 28px;
                font-weight: 700;
                text-align: left !important;
                margin-bottom: 16px;
                line-height: 1.3;
              }

              .about-desc p {
                font-size: 16px;
                color: #555;
                text-align: justify;
                margin-bottom: 24px;
                line-height: 1.7;
              }

              .about-features-grid {
                display: grid;
                grid-template-columns: 1fr 1fr;
                gap: 12px;
              }

              .feature-item {
                display: flex;
                align-items: center;
                gap: 8px;
                background: #EEF5FF;
                border-radius: 8px;
                padding: 10px 14px;
              }

              .feature-item .title {
                font-size: 14px;
                font-weight: 500;
                color: #333;
                margin: 0;
              }

              /* ===== TABLET (769px - 1024px) ===== */
              @media (min-width: 769px) and (max-width: 1024px) {
                .about-home-flex-wrapper {
                  flex-direction: row !important;
                  gap: 24px !important;
                  padding: 30px 20px !important;
                  align-items: center !important;
                }

                .about-video-col,
                .about-text-col {
                  flex: 1 !important;
                }

                .about-text-col .elementor-heading-title {
                  font-size: 22px !important;
                }

                .about-desc p {
                  font-size: 14px !important;
                }

                .feature-item .title {
                  font-size: 13px !important;
                }
              }

              /* ===== MOBILE (max 768px) ===== */
              @media (max-width: 768px) {
                .about-home-flex-wrapper {
                  flex-direction: column !important;
                  gap: 20px !important;
                  padding: 20px 15px !important;
                }

                .about-video-col,
                .about-text-col {
                  width: 100% !important;
                }

                .about-text-col .elementor-heading-title {
                  font-size: 22px !important;
                  text-align: left !important;
                }

                .about-features-grid {
                  grid-template-columns: 1fr 1fr !important;
                  gap: 10px !important;
                }

                .feature-item .title {
                  font-size: 13px !important;
                }
              }

            `}</style>
        </>
    );
};

export default AboutHome;